import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/lib/DateFromUnixTime';
import { authorizedTo, id, meta, nullableUser, entityItem, users } from '../..';

export const inspectionCodec = t.type({
  id,
  todoId: id,
  data: t.type({
    checklistTitle: t.union([t.string, t.null]),
    analyticsDate: t.union([DateFromUnixTime, t.null]),
    conductedAt: t.union([DateFromUnixTime, t.null]),
    dueAt: t.union([DateFromUnixTime, t.null]),
    conductedBy: nullableUser,
    entityItem: t.union([entityItem, t.null]),
  }),
  authorizedTo,
});

export const inspectionListCodec = t.type({
  data: t.array(inspectionCodec),
  meta,
});

export const issueCodec = t.type({
  id,
  todoId: id,
  data: t.type({
    title: t.string,
    createdAt: DateFromUnixTime,
    analyticsDate: DateFromUnixTime,
    dueAt: t.union([DateFromUnixTime, t.null]),
    resolvedBy: nullableUser,
    status: t.number,
    priority: t.number,
    entityItem: t.union([entityItem, t.null]),
    assignees: users,
    resolvedIn: t.union([t.number, t.null]),
    approval: t.union([t.type({
      id: t.number,
      status: t.string,
    }), t.null]),
  }),
  authorizedTo,
});

export const issueListCodec = t.type({
  data: t.array(issueCodec),
  meta,
});

export const questionCodec = t.type({
  id,
  inspectionId: t.union([t.null, id]),
  data: t.type({
    title: t.string,
    response: t.union([t.string, t.null]),
    checklistTitle: t.union([t.string, t.null]),
    conductedAt: t.union([DateFromUnixTime, t.null]),
    conductedBy: nullableUser,
    score: t.number,
  }),
  authorizedTo,
});

export const questionListCodec = t.type({
  data: t.array(questionCodec),
  meta,
});

export const group = t.type({
  title: t.union([t.string, t.null]),
  id: t.union([t.string, t.null]),
  start: t.union([DateFromUnixTime, t.null]),
  end: t.union([DateFromUnixTime, t.null]),
});

export const groupedInspectionCodec = t.type({
  group,
  inspectionCount: t.number,
  overdueInspectionCount: t.number,
  overdueInspectionPercentage: t.number,
});

export const groupedInspectionListCodec = t.type({
  data: t.array(groupedInspectionCodec),
  meta: t.type({
    total: t.union([t.undefined, t.number]),
    inspectionCount: t.number,
    overdueInspectionCount: t.number,
    overdueInspectionPercentage: t.number,
  }),
});

export const groupedIssueCodec = t.type({
  group,
  issueCount: t.number,
  overdueIssueCount: t.number,
  openIssueCount: t.number,
  openIssuePercentage: t.number,
  notResolvedIssueCount: t.number,
  notResolvedIssuePercentage: t.number,
  resolvedIssueCount: t.number,
  averageTimeToResolve: t.number,
  checklistTitle: t.union([t.string, t.null]),
});

export const groupedIssueListCodecMeta = t.type({
  total: t.union([t.undefined, t.number]),
  issueCount: t.number,
  overdueIssueCount: t.number,
  openIssueCount: t.number,
  openIssuePercentage: t.number,
  inProgressIssueCount: t.number,
  resolvedIssueCount: t.number,
  resolvedInTimeIssueCount: t.number,
  resolvedOverdueIssueCount: t.number,
  averageTimeToResolve: t.number,
});

export const groupedIssueListCodec = t.type({
  data: t.array(groupedIssueCodec),
  meta: groupedIssueListCodecMeta,
});

export const groupedQuestionCodec = t.type({
  group,
  count: t.number,
  responseCount: t.number,
  negativeResponseCount: t.number,
  negativeResponsePercentage: t.number,
  maxScore: t.number,
  score: t.number,
  scorePercentage: t.number,
  checklistTitle: t.union([t.string, t.null]),
});

export const groupedQuestionListCodec = t.type({
  data: t.array(groupedQuestionCodec),
  meta: t.type({
    total: t.union([t.undefined, t.number]),
    count: t.number,
    responseCount: t.number,
    negativeResponseCount: t.number,
    negativeResponsePercentage: t.number,
    maxScore: t.number,
    score: t.number,
    scorePercentage: t.number,
  }),
});

export const checklistCodec = t.type({
  questions: t.union([t.record(t.string, t.string), t.array(t.string)]),
});

export const purchaseCodec = t.type({
  id: t.string,
  total: t.number,
  currency: t.string,
  interval: t.string,
  nickname: t.string,
  pricePerUser: t.number,
  usersCount: t.number,
});
